module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    on: {
      "mouseleave": function($event) {
        return _vm.mouseLeave($event)
      },
      "mouseover": function($event) {
        return _vm.mouseEnter($event)
      }
    }
  }, [_c('ext-link', {
    staticClass: "nav-item-link",
    attrs: {
      "to": _vm.to,
      "external": _vm.external,
      "callback": _vm.callback
    }
  }, [_c('span', {
    staticClass: "nav-item-link-text",
    class: {
      multiline: Array.isArray(_vm.text) && _vm.text.length > 1
    },
    domProps: {
      "innerHTML": _vm._s(_vm.textOut)
    }
  })]), (_vm.hover) ? _c('items-list', {
    attrs: {
      "items": _vm.items,
      "level": Number(this.level) + 1,
      "max-level": _vm.maxLevel
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d9230c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/private/SubItem.vue
// module id = b64969dec0c408bce80c
// module chunks = 0